module.exports = __webpack_public_path__ + "static/img/4.cf8a7c99.png";